<!--suppress ALL -->
<template>
  <g-field :label="hasSlotDefault || skipLabel ? '' : 'Tingkat/Semester'"
           class="select-tahun-ajaran" :is-horizontal="hasSlotDefault">
    <label v-if="hasSlotDefault" class="label">{{$t('label.tingkat')}}</label>
    <g-select :value="tingkat" :placeholder="`Pilih tingkat/semester`"
              :disabled="disabled" @change="onChange" v-bind="$attrs">
      <option v-for="th in tingkats" :key="th" :value="th">{{th}}</option>
    </g-select>
    <slot></slot>
  </g-field>
</template>

<script lang="ts">
	import {Component, Prop, Vue} from 'annotation';
	import {tingkats} from '../../../util/PluralVariabels';

	@Component
	export default class SelectTingkat extends Vue {

		@Prop({type: String})
		public tingkat: string;

		@Prop({type: Boolean, default: false})
		public disabled: boolean;

    @Prop({type: Boolean, default: false})
    public skipLabel: boolean;

		public tingkats: Array<any> = tingkats;

		public onChange(val) {
			this.$emit('update:tingkat', val);
			this.$emit('tingkat-selected', val);
		}

		public get hasSlotDefault() {
			return this.$scopedSlots.default || this.$slots.default;
		}
	}
</script>

<style lang="scss">
  .select-tahun-ajaran {
    .select, select {
      min-width: 200px;
      width: 100%;
    }
    &.is-horizontal {
      .field-body {
        align-items: center;
        .field {
          &:first-child {
            width: 150px;
          }
          flex: none;
        }
      }
    }
  }
</style>
